export default __webpack_public_path__ + "static/media/@jualineferraz.3cf7bc2a.jpg";